<template>
		<teleport to="body">
			<div class="modal">
				<transition name="fade">
					<div class="modal-background" @click="closeModal" v-if="openState" />
				</transition>
				<transition name="translate-page-y">
					<div class="modal-content" :class="modalClass" v-if="openState">
						<div class="modal-true-content">
							<div class="modal-header">
								<slot name="header" />
							</div>
							<div class="modal-body">
								<slot name="body" />
							</div>
							<div class="modal-footer">
								<slot name="footer" />
							</div>
						</div>
					</div>
				</transition>
			</div>
		</teleport>
</template>

<script>
export default {
	name: 'modal',
	props: {
		modelValue: {
			type: Boolean,
			required: true
		},
		modalClass: String,
		beforeExit: Function
	},
	computed: {
		openState: {
			get() {
				return this.modelValue;
			},
			set(value) {
				this.$emit('update:modelValue', value);
			}
		}
	},
	methods: {
		async closeModal() {
			if (!this.beforeExit)
				return (this.openState = false);
			return await this.beforeExit();
		}
	}
};
</script>

<style lang="scss">
.modal {
	z-index: 9999;
	.modal-background {
		position: fixed;
		inset: 0;
		background: #0008;
		z-index: 9998;
	}
	.modal-content {
		z-index: 9999;
		position: fixed;
		inset: 0;
		margin: auto;
		background: white;
		border-radius: 10px;
		overflow: hidden;
		display: flex;
		flex-direction: column;
		width: fit-content;
		height: fit-content;
		max-width: 100%;
		max-height: 100%;
		.modal-header {
			text-transform: uppercase;
			font-weight: bolder;
			font-size: 14px;
			text-align: center;
			color: white;
			padding: 5px;
			background: var(--gray-blue);
			border-bottom: 1px solid #fff8;
		}
		.modal-body {
			flex: auto;
			background: var(--darker-blue);
			box-shadow: 2px 2px 8px #0008;
		}
		.modal-footer {
		}
	}
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .4s linear;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.translate-page-y-enter-active,
.translate-page-y-leave-active {
  transform: translateY(0);
  transition: transform 0.25s ease-out, opacity 0.25s ease-out;
}

.translate-page-y-enter-from {
  transform: translateY(10px);
  opacity: 0;
}

.translate-page-y-leave-to {
  transform: translateY(-300px);
  opacity: 0;
}

@media (prefers-reduced-motion: reduce) {
  .translate-page-y-enter-active,
  .translate-page-y-leave-active {
    transition: none;
  }
}
</style>
